import React, { ReactElement } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { Container } from '@material-ui/core';

interface Props {
    children: ReactElement;
}

function AppContainer(props: Props): ReactElement {
    return (
        <>
            <Header />
            {props.children}
            <Container maxWidth="lg">
                <Footer />
            </Container>
        </>
    );
}

export default AppContainer;
